/* eslint-disable default-param-last */
import Constants from './Constants.js'

const initialState = { 
  
}

function select( state = initialState, action ) {
  const grp = action.group
  const ids = action.ids || []

  switch ( action.type ) {

    case Constants.SELECT_ADD: {
      const nState = { ...state }
      nState[grp] = state[grp] == null ? [] : [].concat( state[grp] )
      // make sure there are no duplicates
      ids.forEach( ( id ) => {
        if ( nState[grp].indexOf( id ) < 0 ) {
          nState[grp].push( id )
        }
      } )
      if ( state[grp] && state[grp].length === nState[grp].length ) {
        return state // we did not add anything
      }
      return nState
    }

    case Constants.SELECT_SET: {
      const nState = { ...state }
      const curr = state[grp] || []
      if ( ids.length === 0 && curr.length === 0 ) {
        return state
      }
      if ( ids == null ) {
        // this is a clear
        if ( state[grp] === null || state[grp].length === 0 ) {
          // no change
          return state
        }
        nState[grp] = []
      } else if ( Array.isArray( ids ) ) {
        // check if same
        if ( !isSame( ids, state[grp] ) ) {
          nState[grp] = [].concat( ids )
        } else {
          return state // no change
        }
      } else {
        nState[grp] = [ ids ]
      }
      return nState
    }

    case Constants.SELECT_REMOVE: {
      if ( ids.length === 0 ) {
        return state
      }
      const nState = { ...state }
      const curr = state[grp] || []
      nState[grp] = state[grp] == null ? [] : [].concat( state[grp] )
      if ( Array.isArray( ids ) ) {
        nState[grp] = curr.filter( e => ids.indexOf( e ) < 0 )
      } else {
        nState[grp] = curr.filter( e => ids !== e )
      }
      if ( curr.length === nState[grp].length ) {
        return state // we did not remove anything
      }
      return nState
    }

    case Constants.SELECT_TOGGLE: {
      if ( ids.length === 0 ) {
        return state
      }
      const nState = { ...state }
      const curr = [].concat( state[grp] || [] )
      const add = []
      if ( Array.isArray( ids ) ) {
        ids.forEach( ( e ) => {
          const idx = curr.indexOf( e )
          if ( idx >= 0 ) {
            curr.splice( idx, 1 )
          } else {
            add.push( e )
          }
        } )
        nState[grp] = [].concat( curr, add )
      } else {
        const idx = curr.indexOf( ids )
        if ( idx >= 0 ) {
          curr.splice( idx, 1 )
        } else {
          curr.push( ids )
        }
        nState[grp] = curr
      }
      return nState
    }

    case Constants.SELECT_CLEAR: {
      const nState = { ...state }
      const curr = state[grp] || []
      if ( curr.length === 0 ) {
        return state
      }
      nState[grp] = []
      return nState
    }

    case Constants.SELECT_CLEAR_ALL: {
      return { }
    }
    default: 
      return state
  }
}

function isSame( arr1, arr2 ) {
  if ( arr1 == arr2 ) { // eslint-disable-line
    return true
  }

  if ( arr1 ) {
    if ( arr2 == null ) {
      return arr1.length === 0
    }
    if ( arr1.length !== arr2.length ) {
      return false
    }

    for ( let n = 0; n < arr1.length; n++ ) {
      if ( arr1[n] !== arr2[n] ) {
        return false
      }
    }
    return true
  } if ( arr2.length === 0 ) {
    // arr1 is null
    return true
  }
  return false
}

export default select
